import { render, staticRenderFns } from "./unidades.vue?vue&type=template&id=5f1db05a&scoped=true&"
import script from "./unidades.vue?vue&type=script&lang=js&"
export * from "./unidades.vue?vue&type=script&lang=js&"
import style0 from "./unidades.vue?vue&type=style&index=0&id=5f1db05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1db05a",
  null
  
)

export default component.exports